export const TASK_TEMPLATE_TYPES = {
  NORMAL: 'normal-task',
  NEW_ALF_PATIENT: 'new-alf-patient',
}

export const TASK_TEMPLATE_OPTIONS = [
  { value: TASK_TEMPLATE_TYPES.NORMAL, label: 'Normal' },
  { value: TASK_TEMPLATE_TYPES.NEW_ALF_PATIENT, label: 'New ALF Patient' },
]

export const getTaskTemplateLabel = (templateType) => {
  return (
    TASK_TEMPLATE_OPTIONS.find((option) => option.value === templateType)?.label ||
    TASK_TEMPLATE_OPTIONS.find((option) => option.value === TASK_TEMPLATE_TYPES.NORMAL)?.label ||
    'Normal'
  )
}

export const NEW_ALF_PATIENT_DESCRIPTION =
  'Need Facesheet, Med List, Consent and Check for PA before the patient is scheduled.\nDue Date for task- 1 week; Reminder - After 5 days.'

const LEGACY_NEW_ALF_PATIENT_DESCRIPTIONS = [
  'Card for New ALF PT\n\nDescription mentioned - Need Facesheet, Med List, Consent and Check for PA before the patient is scheduled.\nDue Date for task- 1 week; Reminder - After 5 days.',
]

const NEW_ALF_PATIENT_SUBTASKS = [
  'Facesheet',
  'Med List',
  'Consent',
  'Check for PA',
]

export const inferTaskTemplateType = (task) => {
  if (!task) return TASK_TEMPLATE_TYPES.NORMAL

  const taskTemplateType = task.templateType || task.taskTemplateType || task.type
  if (Object.values(TASK_TEMPLATE_TYPES).includes(taskTemplateType)) {
    return taskTemplateType
  }

  const descriptionMatches =
    task.description === NEW_ALF_PATIENT_DESCRIPTION ||
    LEGACY_NEW_ALF_PATIENT_DESCRIPTIONS.includes(task.description)
  const taskSubtasks = Array.isArray(task.subTasks) ? task.subTasks : []
  const subtaskTitles = taskSubtasks.map((subtask) => subtask?.text).filter(Boolean)
  const hasNewAlfPatientSubtasks = NEW_ALF_PATIENT_SUBTASKS.every((subtask) =>
    subtaskTitles.includes(subtask),
  )

  return descriptionMatches || hasNewAlfPatientSubtasks
    ? TASK_TEMPLATE_TYPES.NEW_ALF_PATIENT
    : TASK_TEMPLATE_TYPES.NORMAL
}

const toLocalDateInputValue = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

const getDateAfterDays = (days) => {
  const date = new Date()
  date.setHours(0, 0, 0, 0)
  date.setDate(date.getDate() + days)
  return toLocalDateInputValue(date)
}

export const buildNewAlfPatientTemplate = () => {
  const dueDate = getDateAfterDays(7)
  const reminderDate = getDateAfterDays(5)
  const createdAt = Date.now()

  return {
    description: NEW_ALF_PATIENT_DESCRIPTION,
    dueDate,
    reminderDate,
    priority: 'Low',
    assignees: [],
    patientDetailsEnabled: false,
    subtasks: NEW_ALF_PATIENT_SUBTASKS.map((text, index) => ({
      //id: createdAt + index,
      SubtaskId: createdAt + index,
      text,
      status: 'To Do',
      assignee: [],
      dueDate,
      isCompleted: false,
      priority: 'Medium',
    })),
  }
}

export const getTaskTemplateDefaults = (templateType) => {
  if (templateType === TASK_TEMPLATE_TYPES.NEW_ALF_PATIENT) {
    return buildNewAlfPatientTemplate()
  }

  return {
    description: '',
    dueDate: '',
    reminderDate: '',
    priority: 'Low',
    assignees: [],
    patientDetailsEnabled: true,
    subtasks: [],
  }
}
